import PropTypes from "prop-types";
import { IconBag, IconGrid, IconQrScanner, IconUser } from "mobile/components/MobileNavIcons";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import { mx } from "../lib/theme";

const HERO_SIZE = 26;
const NAV_SIZE = 24;

function iconSx(hero, size) {
  return {
    color: hero ? "rgba(255,255,255,0.94)" : mx.ink,
    opacity: hero ? 1 : 0.9,
    width: size,
    height: size,
  };
}

export function MxHeaderCatalogIcon({ hero = false, size }) {
  const s = size || (hero ? HERO_SIZE : NAV_SIZE);
  return <IconGrid sx={iconSx(hero, s)} fontSize={s} />;
}

/** QR scanner — sale / install registration (matches native app). */
export function MxHeaderQrScanIcon({ hero = false, size }) {
  const s = size || (hero ? HERO_SIZE : NAV_SIZE);
  return <IconQrScanner sx={iconSx(hero, s)} fontSize={s} />;
}

/** @deprecated Use MxHeaderQrScanIcon */
export function MxHeaderWarrantyIcon(props) {
  return <MxHeaderQrScanIcon {...props} />;
}

export function MxHeaderAccountIcon({ hero = false, size }) {
  const s = size || (hero ? HERO_SIZE : NAV_SIZE);
  return <IconUser sx={iconSx(hero, s)} fontSize={s} />;
}

export function MxHeaderCartIcon({ hero = false, size }) {
  const s = size || (hero ? HERO_SIZE : NAV_SIZE);
  return <IconBag sx={iconSx(hero, s)} fontSize={s} />;
}

export function MxHeaderBackIcon({ size = NAV_SIZE }) {
  return (
    <ArrowBackIosNewOutlinedIcon
      sx={{ ...iconSx(false, size), ml: -0.25, fontSize: size, width: size, height: size }}
    />
  );
}

const iconPropTypes = {
  hero: PropTypes.bool,
  size: PropTypes.number,
};

const iconDefaultProps = {
  hero: false,
  size: null,
};

MxHeaderCatalogIcon.propTypes = iconPropTypes;
MxHeaderCatalogIcon.defaultProps = iconDefaultProps;
MxHeaderQrScanIcon.propTypes = iconPropTypes;
MxHeaderQrScanIcon.defaultProps = iconDefaultProps;
MxHeaderWarrantyIcon.propTypes = iconPropTypes;
MxHeaderWarrantyIcon.defaultProps = iconDefaultProps;
MxHeaderAccountIcon.propTypes = iconPropTypes;
MxHeaderAccountIcon.defaultProps = iconDefaultProps;
MxHeaderCartIcon.propTypes = iconPropTypes;
MxHeaderCartIcon.defaultProps = iconDefaultProps;
MxHeaderBackIcon.propTypes = { size: PropTypes.number };
MxHeaderBackIcon.defaultProps = { size: NAV_SIZE };

export { HERO_SIZE, NAV_SIZE };
